// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"6ab9bd68","4568":"6ab9bd68","7003":"d9feaeb5","7036":"6ab9bd68","7225":"6ab9bd68"}[chunkId] + ".chunk.css";
};